import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth.store';
import { staffChatApi, staffChatKeys } from './api';

export function useStaffChatSummary(open: boolean) {
  const userId = useAuthStore((s) => s.user?.id) ?? '';
  return useQuery({
    queryKey: staffChatKeys.summary(userId),
    queryFn: staffChatApi.summary,
    enabled: !!userId,
    refetchInterval: open ? 5_000 : 20_000,
    retry: false,
  });
}

export function useStaffChatMessages(providerId: string, enabled: boolean) {
  const userId = useAuthStore((s) => s.user?.id) ?? '';
  return useQuery({
    queryKey: staffChatKeys.messages(userId, providerId),
    queryFn: () => staffChatApi.messages(providerId),
    enabled: enabled && !!providerId,
    refetchInterval: 5_000,
    retry: false,
  });
}

export function useSendStaffChatMessage(providerId: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: string) => staffChatApi.send(providerId, body),
    onSuccess: () => client.invalidateQueries({ queryKey: staffChatKeys.all }),
  });
}
